import React from "react";
import { Button } from "@mui/material";

const CustomisedButton = (props) => {
  const { handleClick, variant, children, sx, className } = props;
  const buttonSx = sx
    ? sx
    : {
        width: "150px",
        height: "50px",
        color: `${variant === "contained" ? "black": "white"}`,
        borderColor: "white",
        backgroundColor: `${variant === "contained" ? "white": "#212121"}`,
        borderRadius: "0.5rem",
        "&:hover": {
          borderColor: "white",
          backgroundColor:`${variant === "contained" ? "white": "#212121"}`
        },
      };
  return (
    <Button
      className={className}
      variant={variant}
      sx={buttonSx}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};
export default CustomisedButton;
